import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class UserTypeCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    componentDidMount = () => {
		this._isMounted = true;

        API.Security.get('/query/getUserTypes', {},
        {
            success: (r) => {
                this._isMounted && this.setState({
                    items: r.data.items.map((item) => { return { label: item.description, value: item.userTypeCode } })
                });
            }
        }, { block: false });
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

    render() {
        return (
            <Combo
                {...this.props}
                items={this.state.items}
                searchable={true} />
        )
    }
}

export default UserTypeCombo;

// Mark this as a form component
UserTypeCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/userTypeCombo/UserTypeCombo.js